import React, { Component } from "react";
import { Row, Col, Card } from "reactstrap";

class RowDetailsCellHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { iconBg, icon, title, body1, body2 } = this.props;

    const iconBackground = "icon-wrapper-bg opacity-7 bg-" + iconBg;

    return (
      <Card>
        <Row className="no-gutters">
          <Col sm="12">
            <div className="card no-shadow rm-border bg-transparent widget-chart text-left">
              <div
                className="icon-wrapper rounded-circle"
                style={{ height: "54px" }}
              >
                <div className={iconBackground} />
                <i className={icon} style={{ color: "white" }} />
              </div>
              <div className="widget-chart-content">
                <div className="widget-subheading">
                  <b style={{ color: "black" }}>{title}</b>
                </div>
                <div className="widget-subheading">{body1}</div>
                <div className="widget-subheading">{body2}</div>
              </div>
            </div>
            <div className="divider m-0 d-md-none d-sm-block" />
          </Col>
        </Row>
      </Card>
    );
  }
}

export default RowDetailsCellHeader;



// WEBPACK FOOTER //
// ./src/Clients/PicaC&SVz/components/RowDetailsCellHeader.js